<template>
  <div class="statuslist">
    <div
      v-for="item in ristStatus"
      :class="activeIndex == item.id ? 'active ristStatus' : 'ristStatus'"
      :key="item.id"
    >
      {{ item.name }}
    </div>
  </div>
</template>
<script>
export default {
    name: 'LevelBar',
    props: {
        activeIndex: {
            type: Number,
            default(){
                return 0
            },
        },
        dataList: {
            type: Array,
            default(){
                return []
            },
        },
    },
    data() {
        return {
            ristStatus: [{name:'低',id:1},
                {name:'偏低',id:2},
                {name:'中',id:3},
                {name:'偏高',id:4},
                {name:'高',id:5}], // 风险等级
        }
    },
    created() {
        this.ristStatus = this.dataList.length != 0 ? this.dataList : this.ristStatus
    },
}
</script>
<style lang="scss" scoped>
.statuslist{
  display: flex;
}
.statuslist .ristStatus{
  width: 80px;
  height: 50px;
  line-height: 50px;
  color: #fff;
  background-color: #B5B5B5;
  border-left: 1px solid #fff;
  font-size: 28px;
  text-align: center;
}

.statuslist .active{
  position: relative;
}
.statuslist .active::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  bottom: -20px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom-width: 20px;
  border-bottom-style: solid;
}
.ristStatus:nth-child(1){
  background-color: #009944;
}
.ristStatus:nth-child(1).active::before{
  border-bottom-color: #009944;
}
.ristStatus:nth-child(2){
  background-color: #a2e317;
}
.ristStatus:nth-child(2).active::before{
  border-bottom-color: #a2e317;
}
.ristStatus:nth-child(3){
  background-color: #EB6100;
}
.ristStatus:nth-child(3).active::before{
  border-bottom-color: #EB6100;
}
.ristStatus:nth-child(4){
  background-color: #DD352A;
}
.ristStatus:nth-child(4).active::before{
  border-bottom-color: #DD352A;
}
.ristStatus:nth-child(5){
  background-color: #A01D18;
}
.ristStatus:nth-child(5).active::before{
  border-bottom-color: #A01D18;
}
</style>